module.exports = __webpack_public_path__ + "static/media/icon-label--video.ca127ebd.svg";